import { useSelector } from 'react-redux';

function AccordianSideBar({ allData, selectFunction, selection }) {
  const { comMsg } = useSelector((state) => state.communication);

  return (
    <div className="comm-centre-left-nav">
      <div className="left-nav-tab-main-con grid-sec">
        <div
          className="left-nav-tab-prnt flex-sec"
          onClick={() =>
            selectFunction({
              acord: 'textMsgSec',
              box: 'inbox',
              userType: 'clinic',
            })
          }
        >
          Messages
        </div>
        <div
          className={
            selection?.acord === 'textMsgSec'
              ? `left-nav-tab-main-inr-con grid-sec`
              : `left-nav-tab-main-inr-con grid-sec hide`
          }
        >
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Inbox</div>
            <div className="sbchld-main-con grid-sec">
              <div
                className={
                  selection?.acord === 'textMsgSec' &&
                  selection?.box === 'inbox' &&
                  selection?.userType === 'clinic'
                    ? 'left-nav-tab-sbchild flex-sec com-active-tab'
                    : 'left-nav-tab-sbchild flex-sec'
                }
                onClick={() =>
                  selectFunction({
                    acord: 'textMsgSec',
                    box: 'inbox',
                    userType: 'clinic',
                  })
                }
              >
                Clinic
                <span className="clear-left5">{`${
                  comMsg?.inbox?.clinic
                    ? '(' + comMsg?.inbox?.clinic + ') '
                    : ''
                }`}</span>
              </div>
              <div
                className={
                  selection?.acord === 'textMsgSec' &&
                  selection?.box === 'inbox' &&
                  selection?.userType === 'patient'
                    ? 'left-nav-tab-sbchild flex-sec com-active-tab'
                    : 'left-nav-tab-sbchild flex-sec'
                }
                onClick={() =>
                  selectFunction({
                    acord: 'textMsgSec',
                    box: 'inbox',
                    userType: 'patient',
                  })
                }
              >
                Patient
                <span className="clear-left5">{`${
                  comMsg?.inbox?.patient
                    ? '(' + comMsg?.inbox?.patient + ') '
                    : ''
                }`}</span>
              </div>

              <div className="left-nav-tab-sbchild flex-sec hide">
                New Request
              </div>
            </div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Sent</div>
            <div className="sbchld-main-con grid-sec">
              <div
                className={
                  selection?.acord === 'textMsgSec' &&
                  selection?.box === 'sent' &&
                  selection?.userType === 'patient'
                    ? 'left-nav-tab-sbchild flex-sec com-active-tab'
                    : 'left-nav-tab-sbchild flex-sec'
                }
                onClick={() =>
                  selectFunction({
                    acord: 'textMsgSec',
                    box: 'sent',
                    userType: 'patient',
                  })
                }
              >
                Patient
              </div>
              <div
                className={
                  selection?.acord === 'textMsgSec' &&
                  selection?.box === 'sent' &&
                  selection?.userType === 'clinic'
                    ? 'left-nav-tab-sbchild flex-sec com-active-tab'
                    : 'left-nav-tab-sbchild flex-sec'
                }
                onClick={() =>
                  selectFunction({
                    acord: 'textMsgSec',
                    box: 'sent',
                    userType: 'clinic',
                  })
                }
              >
                Clinic
              </div>
            </div>
          </div>
          <div className="chld-main-con grid-sec">
            <div
              className={
                selection?.acord === 'textMsgSec' && selection?.box === 'outbox'
                  ? 'left-nav-tab-child flex-sec com-active-tab'
                  : 'left-nav-tab-child flex-sec'
              }
              onClick={() =>
                selectFunction({
                  acord: 'textMsgSec',
                  box: 'outbox',
                  userType: '',
                })
              }
            >
              Outbox
            </div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec hide">Archived</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div
              className={
                selection?.acord === 'textMsgSec' && selection?.box === 'trash'
                  ? 'left-nav-tab-child flex-sec com-active-tab'
                  : 'left-nav-tab-child flex-sec'
              }
              onClick={() =>
                selectFunction({
                  acord: 'textMsgSec',
                  box: 'trash',
                  userType: '',
                })
              }
            >
              Trash
            </div>
          </div>
        </div>
      </div>
      <div className="left-nav-tab-main-con grid-sec hide">
        <div
          className="left-nav-tab-prnt flex-sec"
          onClick={() => selectFunction('clinicEmailDiret')}
        >
          Clinic Email & Direct ID
        </div>
        <div
          className={
            selection === 'clinicEmailDiret'
              ? `left-nav-tab-main-inr-con grid-sec`
              : `left-nav-tab-main-inr-con grid-sec hide`
          }
        >
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Inbox</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Sent</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Outbox</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Archived</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Trash</div>
          </div>
        </div>
      </div>
      <div className="left-nav-tab-main-con grid-sec hide">
        <div
          className="left-nav-tab-prnt flex-sec"
          // onClick={() => selectFunction('fax')}
        >
          Fax
        </div>
        <div
          className={
            selection === 'fax'
              ? `left-nav-tab-main-inr-con grid-sec`
              : `left-nav-tab-main-inr-con grid-sec hide`
          }
        >
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Inbox</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Sent</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Outbox</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Archived</div>
          </div>
          <div className="chld-main-con grid-sec">
            <div className="left-nav-tab-child flex-sec">Trash</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccordianSideBar;
